import React from "react";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartBase from "./ChartBase";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
  },
};

const labels = ["Product 1", "Product 2", "Product 3", "Product 4"];

export const data = {
  labels,
  datasets: [
    {
      label: "Dataset 1",
      data: [13, 44, 55, 22],
      backgroundColor: "#4C7B30",
    },
    {
      label: "Dataset 2",
      data: [22, 55, 44, 13],
      backgroundColor: "#4C7B30",
    },
  ],
};

const UnitWiseSell = (props) => {
  return (
    <div className={` ${props.customCss} `}>
      <ChartBase
        chartName="Inventory Distribution"
        subheading="Report Center"
        seeDetail={false}
        extraInfo={false}
        openComparePopUpToggle={props.openComparePopUpToggle}
      >
        <Bar options={options} data={data} />
      </ChartBase>
    </div>
  );
};
export default UnitWiseSell;
